import React, { Children } from "react";
import classNames from "classnames/bind";
import styles from "./buttonGroup.module.scss";

const cx = classNames.bind(styles);

const ButtonGroup = ({ children, className, isCentered }) => {
  return (
    <div className={cx("group", className, isCentered && "centered")}>
      <div className={cx("row1")}>
        {Children.map(children, (child, i) => {
          if (child.props.pos === 1) {
            return <div className={cx("pos1")}>{child}</div>;
          } else if (child.props.pos === 2) {
            return <div className={cx("pos2")}>{child}</div>;
          } else {
            return null;
          }
        })}
      </div>
      <div className={cx("row2")}>
        {Children.map(children, (child, i) => {
          if (child.props.pos === 3) {
            return <div className={cx("pos3")}>{child}</div>;
          } else {
            return null;
          }
        })}
      </div>
    </div>
  );
};

ButtonGroup.PropTypes = {};

export { ButtonGroup as default };
